import genericGlobal from "json/genericGlobal.json";
import { map } from "lodash/fp";
import { genericCarToCar } from "libraries/car";
import { CarState } from "types/cars";

type ReturnType = {
  getGlobalCars: () => CarState[];
  /** @deprecated Prefer getGlobalCars */
  getFranceRentalCars: () => CarState[];
};

export const getGlobalCars = (): CarState[] =>
  map(genericCarToCar)(genericGlobal);

/** @deprecated Prefer getGlobalCars — kept for MLF share-vin helpers. */
export const getFranceRentalCars = getGlobalCars;

const useGlobalCars = (): ReturnType => ({
  getGlobalCars,
  getFranceRentalCars: getGlobalCars,
});

export default useGlobalCars;
